import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { notificationShow } from 'modules/Notifications/actions'
import {
  INITIALIZE,
  MODIFY_BUDGETS_BY_RULE,
  MODIFY_DATES,
  SUBMIT,
  UPDATE_ROW,
} from 'modules/Services/CampaignsEditor/subcomponents/BudgetEditor/types'

/**
 * Custom hook for Budget Editor dispatch logic
 */
export const useBudgetEditor = () => {
  const dispatch = useDispatch()

  const initialize = useCallback(() => {
    dispatch({ type: INITIALIZE })
  }, [dispatch])

  const submit = useCallback(
    (payload, meta) =>
      dispatch({
        type: SUBMIT,
        payload,
        meta,
      }),
    [dispatch],
  )

  const modifyBudgetsByRule = useCallback(
    (payload) => {
      dispatch({
        type: MODIFY_BUDGETS_BY_RULE,
        payload,
      })
    },
    [dispatch],
  )

  const modifyDates = useCallback(
    (payload) => {
      dispatch({
        type: MODIFY_DATES,
        payload,
      })
    },
    [dispatch],
  )

  const showNotification = useCallback(
    (payload) => {
      dispatch(notificationShow(payload))
    },
    [dispatch],
  )

  const updateRow = useCallback(
    (payload) => {
      dispatch({
        type: UPDATE_ROW,
        payload,
      })
    },
    [dispatch],
  )

  return {
    initialize,
    submit,
    modifyBudgetsByRule,
    modifyDates,
    updateRow,
    showNotification,
  }
}
